import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Repository from "../../../../configs/axios/repository";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import logo from "@src/assets/images/logo/smartStudyLogo.svg";
import AnonymousResultWritten from "./anonymousResultWritten";
import AnonymousResult from "./anonymousResult";

const AnonymousTest = ({
    array,
    testType,
    note_id,
    isData,
    test_id,
    noteData,
    canDoIt,
    courseName,
    firstName,
    lastName,
    test_name,
    guid,
}) => {
    const history = useHistory();
    const [loadingData, setLoadingData] = useState(true);
    const [countTest, setCountTest] = useState(0);
    const [isSelectedAnswer, setIsSelectedAnswer] = useState(false);
    const [showSelectionText, setShowSelectionText] = useState(false);
    const [userAnswer, setUserAnswer] = useState("");
    const [isAnswer, setIsAnswer] = useState(true);
    const [allOfAbove, setAlOfAbove] = useState(false);
    const [noneOfAbove, setNoneOfAbove] = useState(false);
    const [test, setTest] = useState(false);
    const [showTiket, setShowTiket] = useState();
    const [answerId, setAnswerId] = useState(0);
    const [toRezultTest, setToRezultTest] = useState(false);
    const [score, setScore] = useState(null);
    const location = useLocation();

    const jaccardFunc = (text1, text2) => {
        const preprocessText = (text) => {
            if (typeof text !== "string") {
                text = text?.toString();
            }
            text = text?.toLowerCase();
            text = text?.replace(/[^\w\s]/g, "");
            return text?.split(/\s+/);
        };
        const set1 = new Set(preprocessText(text1));
        const set2 = new Set(preprocessText(text2));
        const intersection = [...set1].filter((x) => set2.has(x)).length;
        const union = set1.size + set2.size - intersection;
        const jaccardSimilarity = intersection / union;
        return Math.round(jaccardSimilarity * 100);
    };

    const scores = async (item) => {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 0; j < array[i].answers.length; j++) {
                if (
                    array[i].answers[j].correct == true &&
                    array[i].answers[j].correct ==
                        array[i].answers[j].isSelected
                ) {
                    countRightAnswer = countRightAnswer + 1;
                }
            }
        }
        let returnedData = JSON.stringify({
            questions_count: array.length,
            count_right_nswer: countRightAnswer,
            right_percentage:
                " (" +
                Math.floor((100 * countRightAnswer) / array.length) +
                "%)",
        });
        return returnedData;
    };
    const nextTestAbove = async (item) => {
        setShowSelectionText(false);
        setIsSelectedAnswer(false);
        selectedAbove(item);

        if (countTest >= array.length - 1) {
            setScore(scores());
            setToRezultTest(true);
        } else {
            setCountTest(countTest + 1);
        }
    };

    const nextTest = async (item) => {
        setAlOfAbove(false);
        setNoneOfAbove(false);
        if (isSelectedAnswer) {
            setShowSelectionText(false);
            setIsSelectedAnswer(false);
            selectedAnswer(item);

            if (countTest >= array.length - 1) {
                setScore(scores());
                setToRezultTest(true);
            } else {
                setCountTest(countTest + 1);
            }
        } else {
            setShowSelectionText(true);
        }
    };
    const skipTest = async (item) => {
        setShowSelectionText(false);
        setIsSelectedAnswer(false);
        notSelectedAnswer(item);
        if (countTest >= array.length - 1) {
            setScore(scores());
            setToRezultTest(true);
        } else {
            setCountTest(countTest + 1);
        }
    };

    const backTest = async (item) => {
        setShowSelectionText(false);
        setIsSelectedAnswer(false);
        selectedAnswer(item);
        if (countTest <= 0) {
        } else {
            setCountTest(countTest - 1);
        }
    };
    const scoreResults = () => {
        let result = 0;
        let scorArray = array.map((item) => {
            return jaccardFunc(item.answer, item.userAnswer);
        });
        scorArray.forEach((val) => {
            result = result + val;
        });
        return result / scorArray.length;
    };

    const nextWrittenTest = async (item) => {
        if (userAnswer != "") {
            setIsAnswer(true);
            enteredAnswer(item);

            if (countTest >= array.length - 1) {
                setScore(scoreResults());
                setToRezultTest(true);
            } else {
                setUserAnswer("");
                setCountTest(countTest + 1);
            }
        } else {
            setIsAnswer(false);
        }
    };
    const selectedAnswer = async (item) => {
        setAlOfAbove(false);
        setNoneOfAbove(false);
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === item) {
                for (let j = 0; j < array[i].answers.length; j++) {
                    if (array[i].answers[j].id === answerId) {
                        array[i].answers[j].isSelected = true;
                        array[i].answers[j].allOfAbove = false;
                        array[i].answers[j].noneOfAbove = false;
                    } else {
                        array[i].answers[j].isSelected = false;
                        array[i].answers[j].allOfAbove = false;
                        array[i].answers[j].noneOfAbove = false;
                    }
                }
                break;
            }
        }
    };

    const notSelectedAnswer = async (item) => {
        setAlOfAbove(false);
        setNoneOfAbove(false);
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === item) {
                for (let j = 0; j < array[i].answers.length; j++) {
                    array[i].answers[j].isSelected = false;
                    array[i].answers[j].allOfAbove = false;
                    array[i].answers[j].noneOfAbove = false;
                }
                break;
            }
        }
    };

    const selectedAbove = async (item) => {
        if (allOfAbove) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === item) {
                    for (let j = 0; j < array[i].answers.length; j++) {
                        array[i].answers[j].allOfAbove = true;
                        array[i].answers[j].noneOfAbove = false;
                    }
                    break;
                }
            }
        } else if (noneOfAbove) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === item) {
                    for (let j = 0; j < array[i].answers.length; j++) {
                        array[i].answers[j].noneOfAbove = true;
                        array[i].answers[j].allOfAbove = false;
                    }
                    break;
                }
            }
        }
        setAlOfAbove(false);
        setNoneOfAbove(false);
    };
    const enteredAnswer = async (item) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === item) {
                array[i].userAnswer = userAnswer;
                break;
            }
        }
    };

    function getCharForNumber(i) {
        return i > 0 && i < 27 ? String.fromCharCode(i + 64) : null;
    }
    let answersQuestions;
    if (testType == "choice") {
        answersQuestions = array[countTest].answers.map((file, i) => {
            return (
                <div key={i * 8}>
                    <div
                        className={
                            allOfAbove
                                ? "answer selectedAnswer"
                                : isSelectedAnswer && answerId == file.id
                                ? "answer selectedAnswer"
                                : "answer"
                        }
                        onClick={() => {
                            setAlOfAbove(false);
                            setIsSelectedAnswer(true);
                            setAnswerId(file.id);
                        }}
                    >
                        <span>{getCharForNumber(i + 1) + ")"} </span>
                        <span>{file.text}</span>
                    </div>
                </div>
            );
        });
    } else {
        answersQuestions = (file, i) => {
            return (
                <div key={i}>
                    <div
                        className={
                            isSelectedAnswer && answerId == file.id
                                ? "answer selectedAnswer"
                                : "answer"
                        }
                        onClick={() => {
                            setIsSelectedAnswer(true);
                            setAnswerId(file.id);
                        }}
                    >
                        <span>{getCharForNumber(i + 1) + ")"} </span>
                        <span>{file.text}</span>
                    </div>
                </div>
            );
        };
    }
    const handleChange = (event) => {
        setUserAnswer(event.target.value);
    };
    const checkProcessTest = (event) => {
        if (toRezultTest) {
            return (
                <AnonymousResult
                    array={array}
                    testType={testType}
                    note_id={note_id}
                    isData={isData}
                    test_id={test_id}
                    noteData={noteData}
                    canDoIt={canDoIt}
                    courseName={courseName}
                    firstName={firstName}
                    lastName={lastName}
                    test_name={test_name}
                    guid={guid}
                    score={score}
                />
            );
        } else {
            return (
                <Card>
                    <div className="accountingHeaderContent ">
                        <h1 className="mt-4">{test_name}</h1>
                    </div>

                    <div className="testContent">
                        {" "}
                        <div className="question">
                            {array[countTest].question}
                        </div>
                        <div className="answerSection accountingCardBody">
                            <div>
                                <div className="accountingContent">
                                    {answersQuestions}
                                    {showSelectionText ? (
                                        <p className="selectOption">
                                            Please select an option.
                                        </p>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nextBtnDiv">
                        <button
                            className="mt-1"
                            onClick={() => {
                                backTest(array[countTest].id);
                                setAlOfAbove(false);
                                setNoneOfAbove(false);
                            }}
                        >
                            Back
                        </button>

                        <button
                            className={
                                allOfAbove || noneOfAbove
                                    ? "boldNext mt-1"
                                    : "mt-1"
                            }
                            onClick={() => {
                                noneOfAbove || allOfAbove
                                    ? nextTestAbove(array[countTest].id)
                                    : nextTest(array[countTest].id);
                            }}
                        >
                            Next
                        </button>

                        <button
                            className="mt-1"
                            onClick={() => {
                                skipTest(array[countTest].id);
                                setAlOfAbove(false);
                                setNoneOfAbove(false);
                            }}
                        >
                            Skip
                        </button>
                    </div>
                </Card>
            );
        }
    };
    const checkProcessTestWritten = (event) => {
        if (toRezultTest) {
            return (
                <AnonymousResultWritten
                    array={array}
                    testType={testType}
                    note_id={note_id}
                    isData={isData}
                    test_id={test_id}
                    noteData={noteData}
                    canDoIt={canDoIt}
                    courseName={courseName}
                    firstName={firstName}
                    lastName={lastName}
                    test_name={test_name}
                    guid={guid}
                    score={score}
                />
            );
        } else {
            return (
                <Card>
                    <div className="accountingHeaderContent ">
                        <h1 className="mt-4">{test_name}</h1>
                    </div>

                    {array[countTest] == undefined ||
                    array[countTest] == null ? (
                        <div className="d-flex justify-content-center mt-5">
                            <h4>There are no questions in this test.</h4>
                        </div>
                    ) : (
                        <div>
                            <div className="testContent">
                                <div className="question">
                                    {array ? array[countTest]?.question : ""}
                                </div>
                                <div className="answerSection accountingCardBody">
                                    <div className="questionContent">
                                        <textarea
                                            value={userAnswer}
                                            onChange={handleChange}
                                            name="notes"
                                            className="textareaWrittenTest"
                                            placeholder="Enter your answer*"
                                        />
                                        {isAnswer ? (
                                            ""
                                        ) : (
                                            <p className="selectOption">
                                                Please select an option.
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="nextBtnDiv">
                                <button
                                    className="mt-4"
                                    onClick={() => {
                                        nextWrittenTest(array[countTest].id);
                                    }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </Card>
            );
        }
    };

    return loadingData ? (
        <div>
            <div className="testAnonymous">
                <div className="brand-logo">
                    <img src={logo} alt="logo" />
                </div>

                <div className=" anonymousResultSign">
                    <span
                        onClick={() => {
                            history.push({
                                pathname: "/register",
                            });
                        }}
                    >
                        Sign Up
                    </span>
                    <span
                        onClick={() => {
                            history.push({
                                pathname: "/login",
                            });
                        }}
                    >
                        Sign In
                    </span>
                </div>
            </div>

            {testType == "choice"
                ? checkProcessTest()
                : checkProcessTestWritten()}
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default AnonymousTest;
